// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let WizardFormValidation = require("../wizard/WizardFormValidation.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let WizardShowingsValidation = require("../wizard/WizardShowingsValidation.bs.js");
let PropertyWizardFormRelayValidatorsShowings_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowings_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.bs.js");
let PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.bs.js");
let PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.bs.js");
let PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.bs.js");
let PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.node, convertFragment, fRef);
}

let ShowingFragment_showingTypeV5_decode = PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.Utils.showingTypeV5_decode;

let ShowingFragment_showingTypeV5_fromString = PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.Utils.showingTypeV5_fromString;

let ShowingFragment = {
  showingTypeV5_decode: ShowingFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function useIsValid(showing) {
  let showing$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.node, convertFragment, showing);
  return WizardShowingsValidation.validateType(showing$1.type_);
}

let Type = {
  ShowingFragment: ShowingFragment,
  validate: WizardShowingsValidation.validateType,
  useIsValid: useIsValid
};

let convertFragment$1 = PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.node, convertFragment$2, fRef);
}

let ShowingFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

let validate = WizardShowingsValidation.validateDate;

function useIsValid$1(showing, draft) {
  let showing$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.node, convertFragment$2, showing);
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.node, convertFragment$1, draft);
  return WizardShowingsValidation.validateDate(showing$1.date, showing$1.id, draft$1.timeZone);
}

let $$Date = {
  DraftFragment: DraftFragment,
  ShowingFragment: ShowingFragment$1,
  validate: validate,
  useIsValid: useIsValid$1
};

let convertFragment$3 = PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.node, convertFragment$3, fRef);
}

let ShowingFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function useIsValid$2(showing) {
  let showing$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.node, convertFragment$3, showing);
  return WizardShowingsValidation.validateStartTime(showing$1.startTime);
}

let StartTime = {
  ShowingFragment: ShowingFragment$2,
  validate: WizardShowingsValidation.validateStartTime,
  useIsValid: useIsValid$2
};

let convertFragment$4 = PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.node, convertFragment$4, fRef);
}

let ShowingFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

let validate$1 = WizardShowingsValidation.validateEndTime;

function useIsValid$3(showing) {
  let showing$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.node, convertFragment$4, showing);
  return WizardShowingsValidation.validateEndTime(showing$1.endTime, showing$1.startTime);
}

let EndTime = {
  ShowingFragment: ShowingFragment$3,
  validate: validate$1,
  useIsValid: useIsValid$3
};

function validate$2() {
  return "Valid";
}

function useIsValid$4() {
  return "Valid";
}

let Notes = {
  validate: validate$2,
  useIsValid: useIsValid$4
};

let convertFragment$5 = PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.node, convertFragment$5, fRef);
}

let ShowingsFragment_showingTypeV5_decode = PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.Utils.showingTypeV5_decode;

let ShowingsFragment_showingTypeV5_fromString = PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.Utils.showingTypeV5_fromString;

let ShowingsFragment = {
  showingTypeV5_decode: ShowingsFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingsFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function validate$3(showing, timeZone) {
  return WizardShowingsValidation.validate({
    id: showing.id,
    date: showing.date,
    endTime: showing.endTime,
    startTime: showing.startTime,
    type_: showing.type_
  }, timeZone);
}

let Showing = {
  Type: Type,
  $$Date: $$Date,
  StartTime: StartTime,
  EndTime: EndTime,
  Notes: Notes,
  ShowingsFragment: ShowingsFragment,
  validate: validate$3
};

let convertFragment$6 = PropertyWizardFormRelayValidatorsShowings_draft_graphql.Internal.convertFragment;

function waitForFragmentData$6(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowings_draft_graphql.node, convertFragment$6, fRef);
}

function use$6(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowings_draft_graphql.node, convertFragment$6, fRef);
}

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowings_draft_graphql.node, convertFragment$6);
}

function readResolverFragment$6(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowings_draft_graphql.node, convertFragment$6, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelayValidatorsShowings_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelayValidatorsShowings_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment$1 = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$6,
  waitForFragmentData: waitForFragmentData$6,
  use: use$6,
  useOpt: useOpt$6,
  readResolverFragment: readResolverFragment$6
};

function use$7(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowings_draft_graphql.node, convertFragment$6, draft);
  let showings = draft$1.draftProperty.showings.map(s => s.fragmentRefs);
  let showings$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.node, convertFragment$5, showings);
  let match = draft$1.draftProperty.propertyType;
  if (match === "FOR_SALE") {
    return WizardFormValidation.allSubStepsValid(Stdlib_Array.filterMap(showings$1, showing => {
      if (WizardShowingsValidation.isEmpty({
          id: showing.id,
          date: showing.date,
          endTime: showing.endTime,
          startTime: showing.startTime,
          type_: showing.type_
        })) {
        return;
      } else {
        return validate$3(showing, draft$1.timeZone);
      }
    }));
  } else {
    return "Valid";
  }
}

exports.Showing = Showing;
exports.DraftFragment = DraftFragment$1;
exports.use = use$7;
/* WizardFormValidation Not a pure module */
